var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartwatchMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98327 2C9.14645 2 8.3981 2.52098 8.10762 3.30577L7.65955 4.51635C7.77158 4.50553 7.88515 4.5 8.00002 4.5H16C16.1149 4.5 16.2284 4.50553 16.3405 4.51635L15.8924 3.30577C15.6019 2.52098 14.8536 2 14.0167 2H9.98327Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65955 19.4837C7.77158 19.4945 7.88515 19.5 8.00002 19.5H16C16.1149 19.5 16.2284 19.4945 16.3405 19.4837L15.8924 20.6942C15.6019 21.479 14.8536 22 14.0167 22H9.98327C9.14645 22 8.3981 21.479 8.10762 20.6942L7.65955 19.4837Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6H8ZM11.3 8H12.7C12.9761 8 13.2 8.22386 13.2 8.5V10.8H15.5C15.7761 10.8 16 11.0239 16 11.3V12.7C16 12.9761 15.7761 13.2 15.5 13.2H13.2V15.5C13.2 15.7761 12.9761 16 12.7 16H11.3C11.0239 16 10.8 15.7761 10.8 15.5V13.2H8.5C8.22386 13.2 8 12.9761 8 12.7V11.3C8 11.0239 8.22386 10.8 8.5 10.8H10.8V8.5C10.8 8.22386 11.0239 8 11.3 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartwatchMedical);
export default __webpack_public_path__ + "static/media/smartwatch-medical.7d14890978352e84517e4a443f11b591.svg";
export { ForwardRef as ReactComponent };